var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4AlarmClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.43 20.86l-11.11-9.37 2.58-3.06L64 17.81l-2.57 3.05zM64 41a26 26 0 11-52 0 26 26 0 0152 0zm-4 0a22 22 0 10-44 0 22 22 0 0044 0zm-24-1H21v4h19V25h-4v15zM25.68 11.49L23.1 8.43 12 17.81l2.58 3 11.1-9.32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Alarm_clock.2db2bd30.svg";
export { SvgB4AlarmClock as ReactComponent };